module.exports = __webpack_public_path__ + "static/rig-d949bab7105c96f96c2f8b8b872c5925.png";